var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9BA0B1",
    fillRule: "evenodd",
    d: "M0 .995C0 .445.447 0 .997 0h6.006C7.553 0 8 .45 8 .995v8.01c0 .55-.447.995-.997.995H.997C.447 10 0 9.55 0 9.005V.995zm10 8c0-.55.447-.995.997-.995h6.006c.55 0 .997.45.997.995v8.01c0 .55-.447.995-.997.995h-6.006c-.55 0-.997-.45-.997-.995v-8.01zM2 2v6h4V2H2zm10 8v6h4v-6h-4zM0 13.004C0 12.45.447 12 .997 12h6.006c.55 0 .997.451.997 1.004v3.992C8 17.55 7.553 18 7.003 18H.997C.447 18 0 17.549 0 16.996v-3.992zM2 14v2h4v-2H2zm8-12.996C10 .45 10.447 0 10.997 0h6.006c.55 0 .997.451.997 1.004v3.992C18 5.55 17.553 6 17.003 6h-6.006C10.447 6 10 5.549 10 4.996V1.004zM12 2v2h4V2h-4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.fed5a35d910361ac90e19d5da821a4a2.svg";
export { ForwardRef as ReactComponent };